import { render, staticRenderFns } from "./DialogFormCategoryEdit.vue?vue&type=template&id=39ce56f4"
import script from "./DialogFormCategoryEdit.vue?vue&type=script&lang=js"
export * from "./DialogFormCategoryEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports